export default "images/bg5.jpg";